const { coreApi } = require("./coreApi");


export const groupsApi = coreApi.injectEndpoints({
    endpoints: (builder) => ({
        getGroups: builder.query({
            query: (query) => `/teams?${query}`,

            providesTags: ["Teams"]
        }),
        createGroup: builder.mutation({
            query: (data) => ({
                url: `/teams`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Teams"],
        }),
        updateGroup: builder.mutation({
            query: (data) => ({
                url: `/teams/${data.id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Teams"],
        }),
        deleteGroup: builder.mutation({
            query: (id) => ({
                url: `/teams/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Teams"],
        }),
    }),
});

export const { useGetGroupsQuery, useCreateGroupMutation, useUpdateGroupMutation, useDeleteGroupMutation } = groupsApi;

export default groupsApi;
